<template>
  <div
    v-if="title || text || textAdditional"
    class="info-message"
    :class="{
      'info-message--info': type === 'info',
      'info-message--warn': type === 'warn',
      'info-message--error': type === 'error',
      'info-message--with-tooltip': withTooltip,
      'info-message--centered': centered
    }"
    :style="{'background-color': customColor}"
  >
    <h3 v-if="title" class="info-message__title" v-html="title"></h3>
    <template v-if="!withTooltip">
      <p v-if="text" class="info-message__text">{{ text }}</p>
      <p v-if="textAdditional" class="info-message__text-additional">{{ textAdditional }}</p>
    </template>
    <InfoButton
      v-else
      class="info-message__info-btn"
      tooltip-horizontal-align="right"
      tooltip-vertical-align="center"
      :tooltip-text="text"
      max-tooltip-width="240px"
    />
  </div>
</template>

<script>
import InfoButton from './InfoButton'

export default {
  name: 'InfoMessage',
  components: { InfoButton },
  props: {
    type: {
      type: String,
      default: 'info'
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    textAdditional: {
      type: String,
      default: ''
    },
    withTooltip: {
      type: Boolean,
      default: false
    },
    centered: {
      type: Boolean,
      default: false
    },
    customColor: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped lang="sass">

.info-message
  position: relative
  display: block
  width: 100%
  padding: 15px
  border-radius: 3px

  &--centered
    padding: 25px 15px

  &--with-tooltip
    padding: 15px 40px 15px 15px

  &--info
    background-color: rgba(85, 202, 83, 0.1)

  &--error
    background-color: rgba(255, 47, 0, 0.1)

  &--warn
    background-color: rgba(255, 173, 50, 0.1)

.info-message--centered .info-message__title
  text-align: center

.info-message__title
  font-size: 16px
  font-weight: 500
  color: $text-color
  margin: 0

.info-message__text
  font-size: 14px
  font-weight: 400
  color: $text-color
  margin: 10px 0 0

.info-message__text-additional
  font-size: 12px
  font-weight: 400
  color: rgba(51, 51, 51, 0.5)
  margin: 10px 0 0

.info-message__info-btn
  position: absolute
  top: 15px
  right: 15px

::v-deep .info-message__content-wrap
  display: flex
  align-items: flex-start
  flex-flow: row nowrap

  .info-message__content-emoji
    display: block
    flex-shrink: 0
    font-size: 28px
    width: 100%
    max-width: 28px
    margin-right: 20px

  .info-message__text
    width: 100%
    font-weight: 500
    font-size: 14px

</style>
